<template>
    <template-layout>
        <template slot="header">
            <h1 class="title">Mis Datos</h1>
        </template>

        <template slot="content">
            <section class="container">
                <div class="columns">
                    <div class="column is-one-fifth">
                        <aside class="menu">
                            <ul class="menu-list">
                                <li><a @click="onMenuOptionSelected('account-information')" :class="{'active': sectionComponent === 'account-information'}">Datos Personales</a></li>
                                <li><a @click="onMenuOptionSelected('account-password')" :class="{'active': sectionComponent === 'account-password'}">Contraseña</a></li>
                                <li><a @click="onMenuOptionSelected('account-addresses')" :class="{'active': sectionComponent === 'account-addresses'}">Direcciones</a></li>
                            </ul>
                        </aside>
                    </div>

                    <div class="column is-four-fifths">
                        <component :is="sectionComponent" />
                    </div>
                </div>
            </section>
        </template>
    </template-layout>
</template>

<script>
    import TemplateLayout from '../../layout/TemplateLayout';
    import AccountInformation from './AccountInformation';
    import AccountAddresses from './AccountAddresses';
    import AccountPassword from './AccountPassword';

    export default {
        name: 'account',

        data() {
            return {
                sectionComponent: 'account-information',
            }
        },

        components: {
            TemplateLayout,
            AccountInformation,
            AccountAddresses,
            AccountPassword
        },

        methods: {
            onMenuOptionSelected(option) {
                this.sectionComponent = option;
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>